import React from 'react';
import { AuthState } from '@aws-amplify/ui-components';
import Home from './Home';
import Authenticator from './Authenticator';

function Page(props) {
  return props.authState === AuthState.SignedIn && props.user ? <Home token={props.user.signInUserSession.idToken.jwtToken} /> : <Authenticator />;
}

export default Page;
